// extracted by mini-css-extract-plugin
module.exports = {"container":"AuthHeader_container__6sfIa","header":"AuthHeader_header__WePDF","sokiLogo":"AuthHeader_sokiLogo__b2Kga"};